export function hasAvailableStock(hasClientStock: boolean | undefined, baseCntForSale: number | undefined): boolean {
    return !!(hasClientStock || (baseCntForSale ?? 0) > 0);
}

export function hasProductStock(product: {
    client_price?: unknown;
    has_client_stock?: boolean;
    has_stock?: boolean;
    base_stock?: { cnt_for_sale?: number };
}): boolean {
    if (product.client_price) {
        return hasAvailableStock(product.has_client_stock, product.base_stock?.cnt_for_sale);
    }
    return !!product.has_stock;
}

export const NO_PHOTO_SRC = 'https://www.pride.ru/images/no-photo.jpg';
export const COMING_SOON_SRC = '/images/coming-soon.jpg';

export function getPlaceholderPhotoSrc(hasStock: boolean): string {
    return hasStock ? NO_PHOTO_SRC : COMING_SOON_SRC;
}

export function getStockThresholdLabel(cnt: number): string {
    if (cnt <= 0) return 'Нет в наличии';
    if (cnt > 50) return 'более 50 шт.';
    return cnt + ' шт.';
}

export function shouldShowMskStock(baseStockId: string | undefined, clientBaseStockId: string | undefined): boolean {
    return clientBaseStockId !== baseStockId;
}